import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-alumno-checkbox',
  standalone: false,
  templateUrl: './alumno-checkbox.component.html',
  styleUrls: ['./alumno-checkbox.component.scss'],
})
export class AlumnoCheckboxComponent implements OnInit {

  @Input()
  alumno;

  @Input()
  checkForm: UntypedFormGroup;

  private visibleSubject = new BehaviorSubject(false);
  visible$ = this.visibleSubject.asObservable();
  constructor() {
  }

  ngOnInit(): void {
  }

  mouseEnterLeave(value: boolean) {
    this.visibleSubject.next(value);
  }

}
